import type { UserAddress } from '../types';
import { formatAddressLine, formatAddressRecipient } from '../utils/address';

type AddressSelectListProps = {
  name: string;
  addresses: UserAddress[];
  value: string;
  onChange: (value: string) => void;
  newOptionLabel?: string;
};

export default function AddressSelectList({
  name,
  addresses,
  value,
  onChange,
  newOptionLabel = 'Yeni adres gir',
}: AddressSelectListProps) {
  return (
    <div className="address-select-list">
      {addresses.map((address) => (
        <label key={address.id} className={`address-select-item${value === address.id ? ' selected' : ''}`}>
          <input
            type="radio"
            name={name}
            value={address.id}
            checked={value === address.id}
            onChange={() => onChange(address.id)}
          />
          <div className="address-select-content">
            <strong>{address.label}</strong>
            <span>{formatAddressRecipient(address)}</span>
            <span>{formatAddressLine(address)}</span>
            <div className="address-badges">
              {address.isDefaultShipping && (
                <span className="address-badge address-badge-shipping">Varsayılan teslimat</span>
              )}
              {address.isDefaultBilling && (
                <span className="address-badge address-badge-billing">Varsayılan fatura</span>
              )}
            </div>
          </div>
        </label>
      ))}

      <label className={`address-select-item${value === 'new' ? ' selected' : ''}`}>
        <input
          type="radio"
          name={name}
          value="new"
          checked={value === 'new'}
          onChange={() => onChange('new')}
        />
        <div className="address-select-content">
          <strong>{newOptionLabel}</strong>
        </div>
      </label>
    </div>
  );
}
